// Unpublished Work © 2022-2025 Deere & Company.

export const facetGroups = {
    FACET_GROUP_1: 'FACET_GROUP_1',
    FACET_GROUP_2: 'FACET_GROUP_2',
    FACET_GROUP_3: 'FACET_GROUP_3',
    FACET_GROUP_4: 'FACET_GROUP_4',
    FACET_GROUP_5: 'FACET_GROUP_5',
    FACET_GROUP_6: 'FACET_GROUP_6',
    FACET_GROUP_7: 'FACET_GROUP_7'
};
